module.exports = __webpack_public_path__ + "img/true360-color.5b09b498.png";